import React from "react";
import { Container } from "@mui/material";
import { InfoServicioAdminInicio } from "../../../components/Admin/Inicio/ServicioInicio/ServicioInicio";

export const InicioServicioHomeAdmin = () =>{
    return(
         <Container maxWidth='xl'>
            <InfoServicioAdminInicio/>
        </Container>
    )
}